import { BaseModel } from "sjs-base-model";

export default class ProjectGenresModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<ProjectGenresModel>) {
    super();

    this.update(data);
  }
}
